var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounselor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.625H6.125C5.07833 11.625 4.55499 11.625 4.12914 11.7542C3.17034 12.045 2.42003 12.7953 2.12918 13.7541C2 14.18 2 14.7033 2 15.75M11.375 5.625C11.375 7.48896 9.86396 9 8 9C6.13604 9 4.625 7.48896 4.625 5.625C4.625 3.76104 6.13604 2.25 8 2.25C9.86396 2.25 11.375 3.76104 11.375 5.625Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8245_3323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.6C12 11.0399 12 10.7599 12.109 10.546C12.2049 10.3578 12.3578 10.2049 12.546 10.109C12.7599 10 13.0399 10 13.6 10H16.4C16.9601 10 17.2401 10 17.454 10.109C17.6422 10.2049 17.7951 10.3578 17.891 10.546C18 10.7599 18 11.0399 18 11.6V13.4C18 13.9601 18 14.2401 17.891 14.454C17.7951 14.6422 17.6422 14.7951 17.454 14.891C17.2401 15 16.9601 15 16.4 15H15.5612C15.3532 15 15.2492 15 15.1497 15.0204C15.0615 15.0385 14.9761 15.0685 14.8958 15.1095C14.8054 15.1557 14.7242 15.2207 14.5617 15.3506L13.7666 15.9867C13.6279 16.0977 13.5585 16.1532 13.5002 16.1532C13.4494 16.1533 13.4014 16.1302 13.3697 16.0905C13.3333 16.0449 13.3333 15.9561 13.3333 15.7785V15C13.0233 15 12.8683 15 12.7412 14.9659C12.3961 14.8735 12.1265 14.6039 12.0341 14.2588C12 14.1317 12 13.9767 12 13.6667V11.6Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8245_3323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(11 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounselor);
export default __webpack_public_path__ + "static/media/counselor.b0f3c82406dff125e5590a0c8191e7a7.svg";
export { ForwardRef as ReactComponent };